import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { ConfigurationService, HistoryService } from '@philips-internal/oswald-ui-core/lib/services';

@Controller({ fragment: 'custom-route' })
export default class CustomRouteController {

  configuration = ConfigurationService.getAuthenticationConfiguration();

  @OnClick({ target: 'go-to-login-button' })
  onGoToLoginButtonClick(): void {
    HistoryService.push(this.configuration ? this.configuration.routes.login : '');
  }
}
